import * as React from 'react';

export interface FilterControlsWrapperProps {
    children: any;
}

export function FilterControlsWrapper(props: FilterControlsWrapperProps) {
    return (
        <div id='controls-wrapper'>
            {props.children}
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/FilterControlsWrapper.tsx